import * as React from 'react';

const CustomBanner=()=>{
    return(
        <>
        </>
    )
}
export default CustomBanner;